export default __webpack_public_path__ + "static/media/python-client.47d1dde8.svg";